import moment from "moment"
import { useEffect, useState } from "react"
import { Button, ButtonGroup, Col, Form, Modal, Row, Tab, Tabs } from "react-bootstrap"
import { SingleDatePicker } from "react-dates"
import "react-dates/lib/css/_datepicker.css"
import { useTranslation } from "react-i18next"
import Select from "react-select"
import { ValueType } from "react-select/lib/types"
import swal from "sweetalert"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { GLOBAL_CONSTANTS } from "../../constants/constants"
import { RootState } from "../../store"
import { addPromoCodes, editPromoCodes } from "../../store/promoCode.store"

const AddPromoCodeModal = ({
    show,
    handleClose,
    CountryList,
    customers,
    edit
}: {
    show: any
    handleClose: () => void
    CountryList: any
    customers: any
    edit: boolean
}) => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const [key, setKey] = useState("shipping")
    const [startDateFocus, setStartDateFocus] = useState(false)
    const [endDateFocus, setEndDateFocus] = useState(false)
    const [errors, setErrors] = useState({} as Record<string, any>)
    const [disableAddPromo, setDisableAddPromo] = useState<boolean>(false)
    const [loading, setLoading] = useState(false)
    const { promoCode } = useAppSelector((state: RootState) => state.promoCodes)

    const [promoDetails, setPromoDetails] = useState({
        name: "",
        country_code: null,
        subscription_duration: "1",
        discount_type: "flat",
        is_coupon_auto: "manual",
        discount: "",
        start_date: null || "",
        expiry_date: null || "",
        code: "",
        user_ids: [],
        is_open: "1",
        multiple_count_shipping: "1",
        use_count: "1",
        subscription_type: "",
        coupon_type: "shipping",
        active: true,
        id: ""
    })
    const handleCountryChange = (option: ValueType<any>) => {
        setPromoDetails({ ...promoDetails, country_code: option })
    }
    const handleCustomerChange = (option: ValueType<any>) => {
        setPromoDetails({ ...promoDetails, user_ids: option })
    }
    const onDateChange = (date: any, name: string) => {
        if (name === "start_date") setPromoDetails({ ...promoDetails, start_date: date })
        else setPromoDetails({ ...promoDetails, expiry_date: date })
    }
    let imposeMinMax = (e: any) => {
        if (e.target.value != "") {
            if (parseInt(e.target.value) < parseInt(e.target.min)) {
                e.target.value = e.target.min
            }
            if (parseInt(e.target.value) > parseInt(e.target.max)) {
                e.target.value = e.target.max
            }
        } else {
            e.target.value = e.target.min
        }
    }

    let handleChange = (e: any) => {
        if (!e.target.value) setErrors({ ...errors, [e.target.name]: "errors." + e.target.name })
        else delete errors[e.target.name]

        if (e.target.name === "subscription_type") {
            if (e.target.checked === false && promoDetails?.subscription_type !== "both")
                setPromoDetails({ ...promoDetails, [e.target.name]: "" })
            else if (e.target.value === "premium" && promoDetails?.subscription_type === "business")
                setPromoDetails({ ...promoDetails, [e.target.name]: "both" })
            else if (e.target.value === "business" && promoDetails?.subscription_type === "premium")
                setPromoDetails({ ...promoDetails, [e.target.name]: "both" })
            else if (e.target.checked === false && promoDetails?.subscription_type === "both")
                setPromoDetails({
                    ...promoDetails,
                    [e.target.name]: e.target.value === "premium" ? "business" : "premium"
                })
        } else if (e.target.name === "name") {
            setPromoDetails({ ...promoDetails, code: e.target.value })
        }
        setPromoDetails({ ...promoDetails, [e.target.name]: e.target.value })
    }

    var months = [],
        i = 0,
        len = 12
    while (++i <= len) months.push(i)

    const checkAllRequiredFields = () => {
        if (
            promoDetails.name &&
            promoDetails.name !== "" &&
            promoDetails.discount &&
            promoDetails.discount !== "" &&
            promoDetails.code &&
            promoDetails.code !== "" &&
            promoDetails.start_date &&
            promoDetails.start_date !== "" &&
            promoDetails.expiry_date &&
            promoDetails.expiry_date !== "" &&
            promoDetails.use_count &&
            promoDetails.use_count !== ""
        ) {
            setDisableAddPromo(false)
        } else {
            setDisableAddPromo(true)
        }
    }

    useEffect(() => {
        checkAllRequiredFields()
    }, [
        promoDetails.name,
        promoDetails.discount,
        promoDetails.code,
        promoDetails.expiry_date,
        promoDetails.start_date,
        promoDetails.use_count
    ])

    const handleCreatePromo = async (e: any) => {
        let customerData = promoDetails?.user_ids
        let user = [] as any
        if (customerData && customerData.length > 0) {
            customerData.forEach((data: any) => {
                user.push(data?.value)
            })
        }
        let countryData: any = promoDetails?.country_code
        if (countryData) {
            promoDetails.country_code = countryData?.value
        }
        promoDetails.user_ids = user
        promoDetails.start_date = moment(promoDetails?.start_date).format("YYYY-MM-DD")
        promoDetails.expiry_date = moment(promoDetails?.expiry_date).format("YYYY-MM-DD")
        promoDetails.coupon_type = key
        var add: any
        if (edit === true && promoDetails.id) {
            add = await dispatch(editPromoCodes(promoDetails))
        } else {
            add = await dispatch(addPromoCodes(promoDetails))
        }
        if (add?.payload?.data && add?.payload?.data?.status === true) {
            setLoading(false)
            swal({
                title: "",
                text: edit ? t("Promo_Code_is_updated") : t("Promo_Code_is_created"),
                icon: "success"
            }).then(function () {
                handleClose()
            })
        } else {
            setLoading(false)
            swal({
                title: "",
                text: edit ? t("Promo_Code_is_not_updated") : t("Promo_Code_is_not_created"),
                icon: "error"
            }).then(function () {
                handleClose()
            })
        }
    }
    const setActiveTabKey = async (key: string) => {
        if (key === "shipping") {
            setPromoDetails({ ...promoDetails, coupon_type: "shipping" })
            setPromoDetails({ ...promoDetails, subscription_type: "" })
        } else {
            setPromoDetails({ ...promoDetails, coupon_type: "subscription" })
            setPromoDetails({ ...promoDetails, subscription_type: "premium" })
        }
        setKey(key)
    }

    useEffect(() => {
        if (edit === true) {
            let customersData = []
            if (promoCode?.UserPromoCodes && promoCode?.UserPromoCodes.length > 0) {
                customersData = promoCode?.UserPromoCodes?.map((customer: any) => ({
                    value: customer?.user?.id,
                    label: customer?.user?.user_pin + " " + customer?.user?.name
                }))
            }
            let country = []
            if (promoCode?.country_code) {
                country = CountryList?.filter(
                    (selectedCountry: Record<string, any>) => selectedCountry?.value === promoCode?.country_code
                )
            }

            var promoDetails = {
                name: promoCode?.name,
                country_code: country && country.length > 0 ? country[0] : null,
                subscription_duration: promoCode?.subscription_duration,
                is_coupon_auto: "manual",
                discount: promoCode?.discount,
                start_date: promoCode?.start_date,
                expiry_date: promoCode?.expiry_date,
                code: promoCode?.code,
                discount_type: promoCode?.discount_type,
                is_open: promoCode?.is_open === true ? "1" : "0",
                user_ids: customersData,
                multiple_count_shipping: promoCode?.use_count > 1 ? "0" : "1",
                id: promoCode?.id,
                use_count: promoCode?.use_count,
                subscription_type: promoCode?.subscription_type,
                coupon_type: promoCode?.coupon_type,
                active: promoCode?.active
            }
            setKey(promoCode?.coupon_type)
            setPromoDetails(promoDetails)
            checkAllRequiredFields()
        }
    }, [promoCode])
    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
            centered
            dialogClassName="modal-80w">
            <Modal.Header closeButton>
                <Modal.Title>{t("Create a promo code User")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form noValidate className="form">
                    <Tabs
                        id="controlled-tab-example"
                        activeKey={key}
                        onSelect={(k: any) => setActiveTabKey(k)}
                        className="mb-3">
                        <Tab eventKey="shipping" title="Shipping Promo">
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Row>
                                    <Col xs={12} sm={12} md={6} lg={6}>
                                        <Form.Label>{t("Code name")}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder={t("Code name")}
                                            name="name"
                                            required={true}
                                            value={promoDetails?.name}
                                            onChange={(e) => handleChange(e)}
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6}>
                                        <Form.Label>{t("Country")}</Form.Label>
                                        <Select
                                            options={CountryList}
                                            value={promoDetails?.country_code}
                                            name="country_code"
                                            placeholder={t("Country")}
                                            onChange={handleCountryChange}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Tab>
                        <Tab eventKey="subscription" title="Subsription Promo">
                            <Row>
                                <Col xs={12} sm={12} md={6} lg={6}>
                                    <Form.Label>{t("Select Plan")}</Form.Label>
                                    <ButtonGroup className="mx-3">
                                        <div className="mx-2">
                                            <input
                                                type="checkbox"
                                                name="subscription_type"
                                                value="premium"
                                                onChange={(e) => handleChange(e)}
                                                checked={
                                                    promoDetails?.subscription_type === "premium" ||
                                                    promoDetails?.subscription_type === "both"
                                                        ? true
                                                        : false
                                                }
                                            />
                                            <span className="value mx-2">{t("Premium Subscription")}</span>
                                        </div>
                                        <div className="mx-2">
                                            <input
                                                type="checkbox"
                                                name="subscription_type"
                                                value="business"
                                                checked={
                                                    promoDetails?.subscription_type === "business" ||
                                                    promoDetails?.subscription_type === "both"
                                                        ? true
                                                        : false
                                                }
                                                onChange={(e) => handleChange(e)}
                                            />
                                            <span className="value mx-2">{t("Business Subscription")}</span>
                                        </div>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Form.Label>{t("Code name")}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={t("Code name")}
                                        name="name"
                                        required={true}
                                        value={promoDetails?.name}
                                        onChange={(e) => handleChange(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="my-3">
                                <Col xs={12} sm={12} md={6} lg={6}>
                                    <Form.Label>{t("Free Months")}</Form.Label>
                                    <Form.Control
                                        type="number"
                                        step="1"
                                        min="1"
                                        max="120"
                                        placeholder={t("Free Months")}
                                        name="subscription_duration"
                                        value={promoDetails.subscription_duration}
                                        onChange={(e) => handleChange(e)}
                                        onKeyUp={(e) => imposeMinMax(e)}
                                    />
                                </Col>
                                <Col xs={12} sm={12} md={6} lg={6}>
                                    <Form.Label>{t("Country")}</Form.Label>
                                    <Select
                                        options={CountryList}
                                        value={promoDetails?.country_code}
                                        name="country_code"
                                        placeholder={t("Country")}
                                        onChange={handleCountryChange}
                                    />
                                </Col>
                            </Row>
                        </Tab>
                    </Tabs>
                    <div className="card_container row  mx-0 py-3 my-3">
                        <div className="title">{t("Discount Type")}</div>
                        <Row className="my-3">
                            <Col xs={12} sm={12} md={6} lg={6}>
                                <Form.Label className="required">{t("Discount Type")}</Form.Label>
                                <ButtonGroup className="mx-3">
                                    <div className="mx-2">
                                        <input
                                            type="radio"
                                            name="discount_type"
                                            value="flat"
                                            onChange={(e) => handleChange(e)}
                                            checked={promoDetails?.discount_type === "flat" ? true : false}
                                        />
                                        <span className="value mx-2">{t("Flat")}</span>
                                    </div>
                                    <div className="mx-2">
                                        <input
                                            type="radio"
                                            name="discount_type"
                                            value="percent"
                                            onChange={(e) => handleChange(e)}
                                            checked={promoDetails?.discount_type === "percent" ? true : false}
                                        />
                                        <span className="value mx-2">{t("Percentage")}</span>
                                    </div>
                                </ButtonGroup>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={6}>
                                <Form.Label className="required">{t("Coupon Code")}</Form.Label>
                                <ButtonGroup className="mx-3">
                                    <div className="mx-2">
                                        <input
                                            type="radio"
                                            name="is_coupon_auto"
                                            value="auto"
                                            onChange={(e) => handleChange(e)}
                                            checked={promoDetails?.is_coupon_auto === "auto" ? true : false}
                                        />
                                        <span className="value mx-2">{t("Auto")}</span>
                                    </div>
                                    <div className="mx-2">
                                        <input
                                            type="radio"
                                            name="is_coupon_auto"
                                            value="manual"
                                            checked={promoDetails?.is_coupon_auto === "manual" ? true : false}
                                            onChange={(e) => handleChange(e)}
                                        />
                                        <span className="value mx-2">{t("Manual")}</span>
                                    </div>
                                </ButtonGroup>
                                {promoDetails?.is_coupon_auto === "manual" && (
                                    <div>
                                        <Form.Control
                                            type="text"
                                            placeholder={t("Code name")}
                                            name="code"
                                            required={true}
                                            value={promoDetails?.code}
                                            onChange={(e) => handleChange(e)}
                                            className="my-2"
                                        />
                                    </div>
                                )}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Form.Label>{t("Discount Value")}</Form.Label>
                                <div className="d-flex">
                                    <Form.Control
                                        type="text"
                                        placeholder={t("Enter Discount Value")}
                                        name="discount"
                                        required={true}
                                        value={promoDetails?.discount}
                                        onChange={(e) => handleChange(e)}
                                    />
                                    <div className="currency-prefix input-group-text">
                                        {" "}
                                        {GLOBAL_CONSTANTS.CURRENCY}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div className="card_container row  mx-0 py-3 my-3">
                        <div className="title">{t("Code Validity")}</div>
                        <Row className="my-3">
                            <Col xs={12} sm={12} md={6} lg={6} className=" d-flex">
                                <Form.Label className="required my-1">{t("Start Date")}</Form.Label>
                                <div className="mx-3">
                                    <SingleDatePicker
                                        //	date={promoDetails?.start_date}
                                        date={
                                            promoDetails?.start_date ? moment(promoDetails?.start_date) : null
                                        }
                                        onDateChange={(date) => onDateChange(date, "start_date")}
                                        id="start_date"
                                        focused={startDateFocus}
                                        showDefaultInputIcon={true}
                                        inputIconPosition={"after"}
                                        onFocusChange={({ focused }) => setStartDateFocus(focused)}
                                        displayFormat={"DD/MM/YYYY"}
                                    />
                                </div>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={6} className=" d-flex">
                                <Form.Label className="required my-1">{t("End Date")}</Form.Label>

                                <div className="mx-3">
                                    <SingleDatePicker
                                        date={
                                            promoDetails?.expiry_date ? moment(promoDetails?.expiry_date) : null
                                        }
                                        onDateChange={(date) => onDateChange(date, "expiry_date")}
                                        id="expiry_date"
                                        focused={endDateFocus}
                                        showDefaultInputIcon={true}
                                        inputIconPosition={"after"}
                                        onFocusChange={({ focused }) => setEndDateFocus(focused)}
                                        displayFormat={"DD/MM/YYYY"}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    {key !== "subscription" && (
                        <div className="card_container row  mx-0 py-3 my-3">
                            <div className="title">{t("Select Users")}</div>
                            <Row className="my-3">
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Form.Label className="required">{t("User Type")}</Form.Label>
                                    <ButtonGroup className="mx-3">
                                        <div className="mx-2">
                                            <input
                                                type="radio"
                                                name="is_open"
                                                value={"0"}
                                                onChange={(e) => handleChange(e)}
                                                checked={promoDetails?.is_open === "0" ? true : false}
                                            />
                                            <span className="value mx-2">{t("Single/Multiple")}</span>
                                        </div>
                                        <div className="mx-2">
                                            <input
                                                type="radio"
                                                name="is_open"
                                                value={"1"}
                                                checked={promoDetails?.is_open === "1" ? true : false}
                                                onChange={(e) => handleChange(e)}
                                            />
                                            <span className="value mx-2">{t("All Users")}</span>
                                        </div>
                                    </ButtonGroup>
                                    {promoDetails?.is_open === "0" && (
                                        <Select
                                            options={customers}
                                            name="user_ids"
                                            value={promoDetails?.user_ids}
                                            closeMenuOnSelect={false}
                                            placeholder={t("Select_User")}
                                            isMulti
                                            onChange={handleCustomerChange}
                                        />
                                    )}
                                </Col>
                            </Row>
                        </div>
                    )}

                    <div className="card_container row  mx-0 py-3 my-3">
                        <div className="title">{t("Select Count")}</div>
                        <Row className="my-3">
                            <Col xs={12} sm={12} md={12} lg={12} className=" d-flex">
                                <Form.Label className="required my-1">{t("Use Count")}</Form.Label>
                                <ButtonGroup className="mx-3">
                                    <div className="mx-2">
                                        <input
                                            type="radio"
                                            name="multiple_count_shipping"
                                            value={"0"}
                                            checked={
                                                promoDetails?.multiple_count_shipping === "0" ? true : false
                                            }
                                            onChange={(e) => handleChange(e)}
                                        />
                                        <span className="value mx-2">{t("Multiple Use")}</span>
                                    </div>
                                    <div className="mx-2">
                                        <input
                                            type="radio"
                                            name="multiple_count_shipping"
                                            value={"1"}
                                            checked={
                                                promoDetails?.multiple_count_shipping === "1" ? true : false
                                            }
                                            onChange={(e) => handleChange(e)}
                                        />
                                        <span className="value mx-2">{t("Single Use")}</span>
                                    </div>
                                </ButtonGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                {promoDetails?.multiple_count_shipping === "0" && (
                                    <Form.Control
                                        type="number"
                                        step="1"
                                        min="1"
                                        placeholder={t("Use Count")}
                                        name="use_count"
                                        value={promoDetails?.use_count}
                                        onChange={(e) => handleChange(e)}
                                    />
                                )}
                            </Col>
                        </Row>
                    </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    disabled={disableAddPromo}
                    id="btn-primary"
                    className="btn btn-primary"
                    type="submit"
                    onClick={handleCreatePromo}>
                    {t("Save")}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AddPromoCodeModal
